import { CategoryRepository } from "../../../../data/repository/category/CategoryRepository";
import { ProductRepository } from "../../../../data/repository/product/ProductRepository";
import { Message } from "../../../model/Auth";
import { Category } from "../../../model/Category";
import { ResponseState, State } from "../../../model/ResponseState";

export interface DeleteProductUseCase {
  invoke: (id: string) => Promise<ResponseState<Message>>;
}

export class DeleteProductUseCaseImpl implements DeleteProductUseCase {
  private repo: ProductRepository;

  constructor(repo: ProductRepository) {
    this.repo = repo;
  }

  async invoke(id: string): Promise<ResponseState<Message>> {
    try {
      let response = await this.repo.delete(id);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
